import parse from 'html-react-parser';
import DOMPurify from 'dompurify';

/**
 * Safely parses HTML content by sanitizing it first to prevent XSS attacks.
 * Only allows safe HTML tags and attributes for note content.
 *
 */
export function sanitizeAndParseHtml(htmlContent: string) {
  // Sanitize HTML: only allow safe formatting tags
  // This prevents XSS attacks by removing dangerous tags like <script>, <iframe>, etc.
  const sanitized = DOMPurify.sanitize(htmlContent, {
    ALLOWED_TAGS: [
      'p',
      'br',
      'strong',
      'em',
      'u',
      's',
      'strike',
      'ul',
      'ol',
      'li',
      'a',
      'h1',
      'h2',
      'h3',
      'h4',
      'h5',
      'h6',
      'span',
      'blockquote',
      'pre',
      'code',
      'img',
    ],
    // Allow safe CSS properties in style attribute
    ALLOWED_ATTR: ['href', 'target', 'rel', 'style', 'src', 'alt'],
    // Add rel="noopener noreferrer" to external links for security
    ALLOW_DATA_ATTR: false,
    ADD_ATTR: ['target'],
  });

  // Parse the sanitized HTML
  return parse(sanitized);
}

/**
 * Strips all HTML tags and returns plain text.
 * Used for sanitizing user input when creating notes to prevent XSS attacks.
 */
export function sanitizeToPlainText(htmlContent: string): string {
  // Remove all HTML tags by allowing no tags
  const sanitized = DOMPurify.sanitize(htmlContent, {
    ALLOWED_TAGS: [],
    ALLOWED_ATTR: [],
  });

  return sanitized.trim();
}
